var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "confirmation"
  }, [_c('div', {
    staticClass: "heading-icon",
    staticStyle: {
      "background-color": "#f59e0b"
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
    }
  }), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "17",
      "r": "0.5",
      "fill": "currentColor"
    }
  })])]), _c('h1', {
    staticClass: "title-with-underline"
  }, [_vm._v("請確認掛號資料是否正確?")]), _c('div', {
    staticClass: "appointment-info"
  }, _vm._l(_vm.infoItems, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "info-item"
    }, [_c('span', {
      staticClass: "info-label",
      class: item.labelColor
    }, [_vm._v(_vm._s(item.label))]), Array.isArray(item.value) ? _c('div', {
      staticClass: "info-value-group"
    }, _vm._l(item.value, function (val, vIndex) {
      return _c('span', {
        key: vIndex,
        staticClass: "info-value",
        class: item.color
      }, [_vm._v(_vm._s(val))]);
    }), 0) : _c('span', {
      staticClass: "info-value",
      class: item.color
    }, [_vm._v(_vm._s(item.value))])]);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }